import { faImages as faImagesLight } from '@fortawesome/pro-light-svg-icons';
import { faGears, faImages } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { UpdateStartupScreenSettingsForm } from '../forms/StartupScreenSettingsForm';

export type IAppStartupScreenSettingsPageProps = {
  appId: string;
};

export const AppStartupScreenSettingsPage: React.FC<
  IAppStartupScreenSettingsPageProps
> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const parentUrl = `/apps/${appId}/settings`;

  return (
    <>
      <Helmet>
        <title>{t('AppStartupScreenSettingsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Text current>
          <FontAwesomeIcon icon={faImages} />
          {t('AppStartupScreenSettingsPage.title')}
        </Breadcrumbs.Text>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faImagesLight} />}
        title={t('AppStartupScreenSettingsPage.title')}
        subtitle={t('AppStartupScreenSettingsPage.subtitle')}
        previousUrl={parentUrl}
      />

      <UpdateStartupScreenSettingsForm appId={appId} />
    </>
  );
};
